export enum PdfCursorTools {
  SELECT = 0,
  HAND = 1,
  ZOOM = 2
}
